import React, { ReactNode } from 'react';
import './form-success-confirmation.scss';

interface FormSuccessConfirmationProps {
  illustration: ReactNode;
  heading: string;
  children: ReactNode;
}

// Todo: Use this later when other modern dialogues are refactored to support post confirmation screens.
const FormSuccessConfirmation = ({
  illustration,
  heading,
  children,
}: FormSuccessConfirmationProps) => (
  <div className="form-success-confirmation">
    <div className="form-success-confirmation-illustration">{illustration}</div>
    <h2 className="form-success-confirmation-heading">{heading}</h2>
    <p className="form-success-confirmation-body">{children}</p>
  </div>
);

export default FormSuccessConfirmation;
